import type {
  CreateDepartmentsData,
  CreateDepartmentsLambdaResponse,
  Department
} from "@dealer-center/ddc-pages-departments-interface";
import ky, { type KyResponse } from "ky";

const api = ky.create({ prefixUrl: "/landing/nxlambda/departments/" });

export const updateDepartment = async (
  accountId: string,
  oldType: string,
  newType: string,
  newLabel: string,
  userId?: string,
  actingAsUserId?: string
): Promise<KyResponse> => {
  return await api.put("update/" + accountId + "/" + oldType, {
    headers: {
      userId: userId ?? "",
      actingAsUserId: actingAsUserId ?? ""
    },
    json: { newType, newLabel },
    timeout: 30000,
    // The lambda performs multi-step updates (create new hours, update dept, delete old hours).
    // Auto-retries could create duplicate hours records if the operation partially succeeds
    // but the response is lost due to network issues.
    retry: 0
  });
};

export const deleteDepartment = async (
  accountId: string,
  department: string
): Promise<KyResponse> => {
  return await api.delete("delete/" + accountId + "/" + department, {
    retry: 0
  });
};

export const getDepartments = async (
  accountId: string
): Promise<Department[]> => {
  return await api.get("get/" + accountId).json<Department[]>();
};

export const createDepartments = async (
  accountId: string,
  departments: CreateDepartmentsData,
  userId?: string,
  actingAsUserId?: string
): Promise<CreateDepartmentsLambdaResponse> => {
  return await api
    .post("create/" + accountId, {
      headers: {
        userId: userId ?? "",
        actingAsUserId: actingAsUserId ?? ""
      },
      json: { departments }
    })
    .json<CreateDepartmentsLambdaResponse>();
};
